/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiCatProviderProfileUpdate404 } from './model/apiCatProviderProfileUpdate404';
import type { CatProviderProfile } from './model/catProviderProfile';
import type { RetrieveCatProviderProfile } from './model/retrieveCatProviderProfile';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y
  ? 1
  : 2
  ? A
  : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

export const apiCatProviderProfileUpdate = (
  catProviderProfile: NonReadonly<CatProviderProfile>
) => {
  return HTTP<RetrieveCatProviderProfile>({
    url: `/api/v7/provider-profile/cat-profile/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: catProviderProfile,
  });
};

export const getApiCatProviderProfileUpdateMutationOptions = <
  TError = ErrorType<ApiCatProviderProfileUpdate404>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
    TError,
    { data: NonReadonly<CatProviderProfile> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
  TError,
  { data: NonReadonly<CatProviderProfile> },
  TContext
> => {
  const mutationKey = ['apiCatProviderProfileUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
    { data: NonReadonly<CatProviderProfile> }
  > = (props) => {
    const { data } = props ?? {};

    return apiCatProviderProfileUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiCatProviderProfileUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>
>;
export type ApiCatProviderProfileUpdateMutationBody = NonReadonly<CatProviderProfile>;
export type ApiCatProviderProfileUpdateMutationError = ErrorType<ApiCatProviderProfileUpdate404>;

export const useApiCatProviderProfileUpdate = <
  TError = ErrorType<ApiCatProviderProfileUpdate404>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
    TError,
    { data: NonReadonly<CatProviderProfile> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
  TError,
  { data: NonReadonly<CatProviderProfile> },
  TContext
> => {
  const mutationOptions = getApiCatProviderProfileUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
